import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import { OrderingTypeSlug, routes } from 'lib/routes'
import { useRouter } from 'next/router'
import React, { PropsWithChildren } from 'react'

export const LPVenueRouteLink = ({
  orderingType,
  venueSlug,
  children,
}: PropsWithChildren<{
  venueSlug: string
  orderingType?: OrderingTypeSlug
}>) => {
  const { query } = useRouter()
  const { number, area, place, eonxCheckInId, eonx_venue_id } = query

  if (orderingType) {
    return (
      <RouteLink
        key={venueSlug}
        route={routes.menuCategories}
        replace={!!eonxCheckInId}
        pathData={{
          venueSlug: venueSlug,
          orderingTypeSlug: orderingType!,
          number,
          area,
          place,
          eonxCheckInId,
          eonx_venue_id,
        }}
      >
        <a>{children}</a>
      </RouteLink>
    )
  }

  return (
    <RouteLink
      key={venueSlug}
      route={routes.venue}
      replace={!!eonxCheckInId}
      pathData={{
        venueSlug: venueSlug!,
        number,
        area,
        place,
        eonxCheckInId,
        eonx_venue_id,
      }}
    >
      <a>{children}</a>
    </RouteLink>
  )
}
